import HeaderSkeleton from "./HeaderSkeleton";
import StartBannerSkeleton from "./StartBannerSkeleton";
import VehicleCardSkeleton from "./VehicleCardSkeleton";
import TabsSectionSkeleton from "./TabsSectionSkeleton";

const ReservationDetailsPageSkeleton = () => (
    <div className="flex flex-col gap-3">
        <HeaderSkeleton />
        <StartBannerSkeleton />
        <VehicleCardSkeleton />
        <TabsSectionSkeleton />
    </div>
);

export default ReservationDetailsPageSkeleton;
